/** "Updated 14:46:32" indicator for live-data pages.
 *
 * Reflects react-query's `dataUpdatedAt` timestamp — the last time a
 * successful fetch completed. Consumer passes a ticking `now` so the
 * "X seconds/minutes ago" text keeps refreshing without this component
 * managing its own timer. */

import type { ReactElement } from "react";

interface Props {
  updatedAtMs: number;
  now: Date;
}

export function UpdatedAt({ updatedAtMs, now }: Readonly<Props>): ReactElement | null {
  if (updatedAtMs === 0) return null;
  const ageMs = Math.max(0, now.getTime() - updatedAtMs);
  return (
    <div className="flex items-center gap-1.5 text-[11px] text-ink-muted">
      <i className="ti ti-refresh text-xs" />
      Updated {formatAge(ageMs, updatedAtMs)}
    </div>
  );
}

function formatAge(ageMs: number, updatedAtMs: number): string {
  const seconds = Math.floor(ageMs / 1000);
  if (seconds < 60) return `${String(seconds)}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${String(minutes)}m ago`;
  // Fall back to a wall-clock timestamp for older data.
  const d = new Date(updatedAtMs);
  const h = String(d.getHours()).padStart(2, "0");
  const m = String(d.getMinutes()).padStart(2, "0");
  return `at ${h}:${m}`;
}
